import { Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#051024] text-white/70 border-t border-white/10"
    >
      <div className="cgp-container py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="font-serif text-white text-2xl leading-snug max-w-md">
            Fueling Growth. Creating Value.
          </p>
          <p className="mt-5 text-white/55 leading-relaxed max-w-md">
            A boutique advisory and FMCG holding group helping Indian businesses
            unlock capital, build brands, and scale with conviction.
          </p>
        </div>

        <div className="md:col-span-3">
          <h5 className="text-[10px] uppercase tracking-[0.28em] text-[#C8A24A] font-semibold">
            Divisions
          </h5>
          <ul className="mt-5 space-y-3 text-white/75">
            <li>
              <a
                data-testid="footer-link-capital"
                href="/capital-funding"
                className="hover:text-[#C8A24A] transition-colors"
              >
                Capital Funding
              </a>
            </li>
            <li>
              <a
                data-testid="footer-link-fmcg"
                href="/fmcg"
                className="hover:text-[#C8A24A] transition-colors"
              >
                FMCG Brand House
              </a>
            </li>
            <li>
              <a
                data-testid="footer-link-leadership"
                href="/#leadership"
                className="hover:text-[#C8A24A] transition-colors"
              >
                Leadership
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h5 className="text-[10px] uppercase tracking-[0.28em] text-[#C8A24A] font-semibold">
            Contact
          </h5>
          <ul className="mt-5 space-y-3 text-white/85 text-sm">
            <li>
              <a
                data-testid="footer-phone-1"
                href="tel:+919891892778"
                className="flex items-center gap-3 hover:text-[#C8A24A] transition-colors"
              >
                <Phone size={14} className="text-[#C8A24A] shrink-0" />
                +91 98918 92778
              </a>
            </li>
            <li>
              <a
                data-testid="footer-phone-2"
                href="tel:+919810700890"
                className="flex items-center gap-3 hover:text-[#C8A24A] transition-colors"
              >
                <Phone size={14} className="text-[#C8A24A] shrink-0" />
                +91 98107 00890
              </a>
            </li>
            <li>
              <a
                data-testid="footer-phone-3"
                href="tel:+919899940615"
                className="flex items-center gap-3 hover:text-[#C8A24A] transition-colors"
              >
                <Phone size={14} className="text-[#C8A24A] shrink-0" />
                +91 98999 40615
              </a>
            </li>
            <li className="pt-2">
              <a
                data-testid="footer-email"
                href="mailto:sales@catalystglobalpartners.in"
                className="flex items-center gap-3 hover:text-[#C8A24A] transition-colors break-all"
              >
                <Mail size={14} className="text-[#C8A24A] shrink-0" />{" "}
                sales@catalystglobalpartners.in
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="cgp-container py-6 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-xs text-white/45">
          <div>
            © {new Date().getFullYear()} Catalyst Global Partners. All rights
            reserved.
          </div>
          <div className="uppercase tracking-[0.28em]">
            Strategic Funding · Smart Solutions · Sustainable Growth
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div
          data-testid="footer-credit"
          className="cgp-container py-4 text-center text-[11px] text-white/35 tracking-[0.18em] uppercase"
        >
          Created &amp; Visualised by{" "}
          <span className="text-[#C8A24A]/80 font-medium">Anhadd Chopra</span>
        </div>
      </div>
    </footer>
  );
}
